import ArrayInput from './ArrayInput'
import BooleanInput from './BooleanInput'
import DateInput from './DateInput'
import FunctionalitySelector from './FunctionalitySelector'
import StringInput from './StringInput'
import TimeInput from './TimeInput'
import NumberInput from './NumberInput'
import IntegerInput from './IntegerInput'
import SelectInput from './SelectInput'
import RadioInput from './RadioInput'
import JsonEditor from './JsonInput'
import TextAreaInput from './TextAreaInput'
import InlineUploadFileInput from './InlineUploadFileInput'

export default EditableInput = ({ type, subType, ...props }) ->
  switch
    when type is 'functionality'
      <FunctionalitySelector {props...} />
    when type in Weaver.Attribute.typesDate
      <DateInput {props...} />
    when type in Weaver.Attribute.typesTime
      <TimeInput {props...} />
    when type in [ Weaver.Attribute.typesDouble..., Weaver.Attribute.typesInteger... ]
      <NumberInput {props...} />
    when type in Weaver.Attribute.typesBoolean
      <BooleanInput {props...} />
    when type is 'select'
      <SelectInput {props...} />
    when type is 'radio'
      <RadioInput {props...} />
    when type in [ 'json', 'object' ]
      <JsonEditor {props...} />
    when type is 'multiline'
      <TextAreaInput {props... } />
    when type in [ 'fileUid', 'fileId', 'wvr:fileId' ]
      <InlineUploadFileInput {...props} />
    when type in [ 'array' ]
      <ArrayInput {props...} />
    when type is 'string'
      if subType in ["json", "json5", "json5-with-vars"]
        mode = if subType is "json" then "json" else "json5"
        <JsonEditor mode={mode} {props...} />
      else
        <StringInput {props...} />
    else
      <StringInput {props...} />
